module.exports = __webpack_public_path__ + "img/yishi15.7c75edb1.jpg";